import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import './VeiculoseciaAnuncio.scss';
import api from '../../../config/configApi';
import VeiculoseciaVehicleCard from '../../../components/Veiculosecia/VeiculoseciaVehicleCard';
import { Alert, Button, CircularProgress, Divider, Typography } from '@mui/material';
import Slider from 'react-slick';
import { MdYoutubeSearchedFor, MdZoomIn, MdZoomOut } from 'react-icons/md';
import { RiArrowLeftSLine, RiArrowRightSLine } from 'react-icons/ri';
import { BsFillTelephoneFill } from 'react-icons/bs';
import { FaWhatsapp } from 'react-icons/fa';
import { formatKm, formatValor } from '../../../utils/webConstants';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

function VeiculoseciaAnuncio() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [veiculo, setVeiculo] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const sliderRefBig = useRef(null);
    const sliderRefSml = useRef(null);
    const url = window.location.href;

    // ESTADO DOS RELACIONADOS
    const [relacionados, setRelacionados] = useState([]);
    const [isLoadingRelacionados, setIsLoadingRelacionados] = useState(true);
    const [errorRelacionados, setErrorRelacionados] = useState(null);

    // HANDLERS E ESTADOS DO MODAL
    const [openModal, setOpenModal] = useState(false);
    const [initialSlideModal, setInitialSlideModal] = useState(0);

    // ESTADOS PARA CONTROLE DE ZOOM NO MODAL
    const [scale, setScale] = useState(1);
    const [position, setPosition] = useState({ x: 0, y: 0 });

    // Referências para armazenar dados de toque temporários
    const touchStart = useRef(null);
    const touchDistance = useRef(0);
    const initialPosition = useRef({ x: 0, y: 0 });
    const initialScale = useRef(1);

    const handleClickOpen = (index) => {
        setInitialSlideModal(index);
        setOpenModal(true);
    }

    const handleClose = () => {
        setOpenModal(false);
        // Reseta o zoom e a posição ao fechar o modal
        setScale(1);
        setPosition({ x: 0, y: 0 });
    }

    // SLIDERS DO MODAL (Não usaremos o React Slick, mas o estado para o slide inicial é útil)
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const sliderRefModal = useRef(null);

    var settingsBig = {
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
    }

    var settingsSml = {
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        arrows: false
    }

    // A lógica do modal agora é controlada por estados e eventos de toque
    // var settingsModal = {
    //     focusOnSelect: false,
    //     swipe: false,
    //     infinite: false,
    //     speed: 500,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     initialSlide: initialSlideModal,
    //     arrows: false
    // }

    useEffect(() => {
        const fetchVeiculo = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const response = await api.get(`/api/anuncio/${id}`);
                setVeiculo(response.data);
            } catch (err) {
                const errMessage = err.response?.data?.msg || err.message || 'Erro desconhecido ao carregar veículo.';
                setError(errMessage);
                if (err.response && err.response.status === 404) {
                    navigate('/notfound')
                }

            } finally {
                setIsLoading(false);
            }
        }

        fetchVeiculo();
    }, [id, navigate])

    useEffect(() => {
        const fetchRelacionados = async () => {
            setIsLoadingRelacionados(true);
            setErrorRelacionados(null);
            try {
                const response = await api.get(`/api/anuncios?veiculoId=${id}`);
                const vehiclesWithSortedImages = response.data.data.map(vehicle => {
                    const sortedImages = [...vehicle.imagens].sort((a, b) => a.id - b.id);
                    return { ...vehicle, imagens: sortedImages };
                })
                setRelacionados(vehiclesWithSortedImages);
            } catch (err) {
                const errMessage = err.response?.data?.msg || err.message || 'Erro desconhecido ao carregar relacionados.';
                setErrorRelacionados(errMessage);
                setRelacionados([]);
            } finally {
                setIsLoadingRelacionados(false)
            }
        }

        fetchRelacionados();
    }, [id])

    function formatObs() {
        let obs = veiculo.observacao;
        obs = obs.replace(/(\r\n|\n\r|\r|\n)/g, "<br />");

        return { __html: obs };
    }

    function goToSlide(index) {
        sliderRefBig.current.slickGoTo(index);
        sliderRefSml.current.slickGoTo(index);
    }

    // --- Lógica de eventos de toque para zoom e pan ---

    const getDistance = (touches) => {
        const [t1, t2] = touches;
        return Math.sqrt(Math.pow(t2.clientX - t1.clientX, 2) + Math.pow(t2.clientY - t1.clientY, 2));
    };

    const onTouchStart = (e) => {
        e.preventDefault();
        const touches = e.touches;
        touchStart.current = { x: touches[0].clientX, y: touches[0].clientY };
        initialPosition.current = position;
        initialScale.current = scale;

        if (touches.length === 2) {
            touchDistance.current = getDistance(touches);
        }
    };

    const onTouchMove = (e) => {
        e.preventDefault();
        const touches = e.touches;

        if (touches.length === 2) {
            // Lógica de pinch-to-zoom (pinça para zoom).
            const newDistance = getDistance(touches);
            const newScale = (newDistance / touchDistance.current) * initialScale.current;
            setScale(Math.min(Math.max(newScale, 1), 5)); // O zoom começa a partir de 1
        } else if (touches.length === 1 && scale > 1) {
            // Lógica de pan (arrastar).
            const dx = touches[0].clientX - touchStart.current.x;
            const dy = touches[0].clientY - touchStart.current.y;
            setPosition({
                x: initialPosition.current.x + dx,
                y: initialPosition.current.y + dy,
            });
        }
    };

    const onTouchEnd = () => {
        touchStart.current = null;
        touchDistance.current = 0;
    };

    // Funções para controle manual do zoom.
    const zoomIn = () => setScale(currentScale => Math.min(currentScale + 0.5, 5));
    const zoomOut = () => setScale(currentScale => Math.max(currentScale - 0.5, 1));
    const resetTransform = () => {
        setScale(1);
        setPosition({ x: 0, y: 0 });
    };

    const nextImage = () => {
        if (currentImageIndex < veiculo.imagens.length - 1) {
            setCurrentImageIndex(currentImageIndex + 1);
        }
    };

    const prevImage = () => {
        if (currentImageIndex > 0) {
            setCurrentImageIndex(currentImageIndex - 1);
        }
    };

    useEffect(() => {
        if (openModal) {
            setCurrentImageIndex(initialSlideModal);
        }
    }, [openModal, initialSlideModal]);


    return (
        <>
            {isLoading && !error && (
                <div className='d-flex align-items-center justify-content-center p-4'>
                    <CircularProgress />
                </div>
            )}
            {!isLoading && error && (
                <div className='d-flex align-items-center justify-content-center p-4'>
                    <Alert severity='error'>{error}</Alert>
                </div>
            )}
            {!isLoading && !error && (
                <>
                    <div className='veiculosecia__content bg-white' style={{ paddingTop: 0 }}>
                        <div className='vehicle row'>
                            <div className='vehicle__left col-md-6 position-relative'>
                                <div>
                                    <Button
                                        className='arrow__prev'
                                        onClick={() => sliderRefBig.current.slickPrev()}
                                    >
                                        <RiArrowLeftSLine className='arrow__icon' />
                                    </Button>

                                    <Button
                                        className='arrow__next'
                                        onClick={() => sliderRefBig.current.slickNext()}
                                    >
                                        <RiArrowRightSLine className='arrow__icon' />
                                    </Button>

                                    <Dialog
                                        open={openModal}
                                        onClose={handleClose}
                                        PaperProps={{
                                            style: {
                                                backgroundColor: 'transparent',
                                                boxShadow: 'none',
                                                overflow: 'hidden',
                                                maxWidth: '100%'
                                            },
                                        }}
                                        fullScreen
                                    >
                                        <DialogContent style={{ padding: 0, position: 'relative' }}>
                                            {/* Botões de navegação no Modal */}
                                            <Button
                                                className='arrow__prev'
                                                onClick={prevImage}
                                                style={{ zIndex: 100, position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                disabled={currentImageIndex === 0}
                                            >
                                                <RiArrowLeftSLine className='arrow__icon' style={{ color: '#fff', fontSize: '40px' }} />
                                            </Button>
                                            <Button
                                                className='arrow__next'
                                                onClick={nextImage}
                                                style={{ zIndex: 100, position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                disabled={currentImageIndex === (veiculo.imagens?.length - 1)}
                                            >
                                                <RiArrowRightSLine className='arrow__icon' style={{ color: '#fff', fontSize: '40px' }} />
                                            </Button>

                                            {/* Botão de fechar */}
                                            <Button onClick={handleClose} style={{ zIndex: 100, position: 'absolute', top: '10px', right: '10px', color: '#fff', background: '#292929' }}>Fechar</Button>

                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    width: '100%',
                                                    height: '100%',
                                                    overflow: 'hidden'
                                                }}
                                                onTouchStart={onTouchStart}
                                                onTouchMove={onTouchMove}
                                                onTouchEnd={onTouchEnd}
                                            >
                                                {veiculo.imagens && veiculo.imagens.length > 0 ? (
                                                    <img
                                                        className='w-100'
                                                        src={veiculo.imagens[currentImageIndex].ftp_url}
                                                        alt={veiculo.modelo}
                                                        style={{
                                                            objectFit: 'contain',
                                                            maxHeight: '100vh',
                                                            maxWidth: '100%',
                                                            transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
                                                            transformOrigin: 'center center',
                                                            transition: 'transform 0.1s ease-out'
                                                        }}
                                                        onError={({ currentTarget }) => {
                                                            currentTarget.onerror = null;
                                                            currentTarget.src = "/default.jpg";
                                                        }}
                                                    />
                                                ) : (
                                                    <p style={{ color: '#fff', textAlign: 'center' }}>Nenhuma imagem disponível.</p>
                                                )}
                                            </div>
                                        </DialogContent>
                                        <DialogActions style={{ justifyContent: 'center', paddingTop: '10px' }}>
                                            <Button onClick={zoomIn} sx={{ background: '#FFF' }}><MdZoomIn style={{ fontSize: '20px' }} /></Button>
                                            <Button onClick={zoomOut} sx={{ background: '#FFF' }}><MdZoomOut style={{ fontSize: '20px' }} /></Button>
                                            <Button onClick={resetTransform} sx={{ background: '#FFF' }}><MdYoutubeSearchedFor style={{ fontSize: '20px' }} /></Button>
                                        </DialogActions>
                                    </Dialog>
                                    <Slider
                                        {...settingsBig}
                                        ref={sliderRefBig}
                                    >
                                        {veiculo.imagens && veiculo.imagens.length > 0 ? (
                                            veiculo.imagens.map((imagem, index) => (
                                                <div
                                                    key={index}
                                                    className='vehicle__image'
                                                    onClick={() => handleClickOpen(index)}
                                                >
                                                    <img
                                                        className='w-100'
                                                        src={imagem.ftp_url}
                                                        alt={veiculo.modelo}
                                                        onError={({ currentTarget }) => {
                                                            currentTarget.onerror = null;
                                                            currentTarget.src = "/default.jpg";
                                                        }}
                                                    />
                                                </div>
                                            ))
                                        ) : (
                                            <p>Nenhuma imagem disponível para este anúncio.</p>
                                        )}
                                    </Slider>
                                </div>

                                <div className='position-relative'>
                                    <Button
                                        className='arrow__prev sml'
                                        onClick={() => sliderRefSml.current.slickPrev()}
                                    >
                                        <RiArrowLeftSLine className='arrow__icon' style={{ fontSize: '12px' }} />
                                    </Button>

                                    <Button
                                        className='arrow__next sml'
                                        onClick={() => sliderRefSml.current.slickNext()}
                                    >
                                        <RiArrowRightSLine className='arrow__icon' style={{ fontSize: '12px' }} />
                                    </Button>
                                    <Slider
                                        {...settingsSml}
                                        ref={sliderRefSml}
                                        className='sliderSml'
                                    >
                                        {veiculo.imagens && veiculo.imagens.length > 0 ? (
                                            veiculo.imagens.map((imagem, index) => (
                                                <div
                                                    key={index}
                                                    className='item sml'
                                                    onClick={() => goToSlide(index)}
                                                >
                                                    <img
                                                        className='w-100'
                                                        src={imagem.ftp_url}
                                                        alt={veiculo.modelo}
                                                        onError={({ currentTarget }) => {
                                                            currentTarget.onerror = null;
                                                            currentTarget.src = "/default.jpg";
                                                        }}
                                                    />
                                                </div>
                                            ))
                                        ) : (
                                            <p>Nenhuma imagem disponível para este anúncio.</p>
                                        )}
                                    </Slider>
                                </div>
                            </div>
                            <div className='vehicle__right col-md-6 d-flex flex-column pt-4'>
                                {veiculo.categoria.id === 1 &&
                                    <h4 style={{ textTransform: 'uppercase', lineHeight: '32px', fontWeight: 600 }}>{veiculo.marca.nome} {veiculo.modelo} {veiculo.tracao} {veiculo.ano_fabricacao}/{veiculo.ano_modelo} {veiculo.cambio}</h4>
                                }
                                {veiculo.categoria.id === 2 &&
                                    <h4 style={{ textTransform: 'uppercase', lineHeight: '32px', fontWeight: 600 }}>{veiculo.tipo} {veiculo.marca.nome} {veiculo.modelo} {veiculo.ano_fabricacao}/{veiculo.ano_modelo}</h4>
                                }
                                {veiculo.categoria.id === 3 &&
                                    <h4 style={{ textTransform: 'uppercase', lineHeight: '32px', fontWeight: 600 }}>{veiculo.marca.nome} {veiculo.modelo} {veiculo.ano_fabricacao}/{veiculo.ano_modelo}</h4>
                                }

                                <h4 style={{ fontWeight: 600, fontSize: '32px' }}>{formatValor(veiculo.valor)}</h4>

                                <span className='border__details' />

                                <table>
                                    <tbody>
                                        <tr>
                                            <td className='detail__title'>Marca</td>
                                            <td>{veiculo.marca.nome.toLowerCase()}</td>
                                        </tr>

                                        <tr>
                                            <td className='detail__title'>Modelo</td>
                                            <td>{veiculo.modelo.toLowerCase()}</td>
                                        </tr>

                                        <tr>
                                            <td className='detail__title'>Ano</td>
                                            <td>{veiculo.ano_fabricacao}/{veiculo.ano_modelo}</td>
                                        </tr>

                                        {(veiculo.categoria.id === 1 || veiculo.categoria.id === 3) && (
                                            <tr>
                                                <td className='detail__title'>Km</td>
                                                <td>{formatKm(veiculo.km)}</td>
                                            </tr>
                                        )}

                                        {veiculo.categoria.id === 2 && (
                                            <tr>
                                                <td className='detail__title'>Tipo</td>
                                                <td>{veiculo.tipo.toLowerCase()}</td>
                                            </tr>
                                        )}

                                        <tr>
                                            <td className='detail__title'>Cor</td>
                                            <td>{veiculo.cor.toLowerCase()}</td>
                                        </tr>

                                        {(veiculo.categoria.id === 1 || veiculo.categoria.id === 3) && (
                                            <>
                                                <tr>
                                                    <td className='detail__title'>Combustível</td>
                                                    <td>{veiculo.combustivel.toLowerCase()}</td>
                                                </tr>

                                                <tr>
                                                    <td className='detail__title'>Câmbio</td>
                                                    <td>{veiculo.cambio.toLowerCase()}</td>
                                                </tr>

                                                {veiculo.categoria.id === 1 && (
                                                    <>
                                                        <tr>
                                                            <td className='detail__title'>Tração</td>
                                                            <td>{veiculo.tracao.toLowerCase()}</td>
                                                        </tr>

                                                        <tr>
                                                            <td className='detail__title'>Carroceria</td>
                                                            <td>{veiculo.carroceria.toLowerCase()}</td>
                                                        </tr>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </tbody>
                                </table>

                                <div className='mt-auto'>
                                    <h4 className='info__title'>Departamento de vendas</h4>
                                    <div className='btn__group d-flex justify-content-between mt-1'>
                                        <Button
                                            startIcon={<BsFillTelephoneFill />}
                                            variant='contained'
                                            className='btn__phone'
                                        >
                                            (66) 99981-5612
                                        </Button>
                                        <Button
                                            startIcon={<FaWhatsapp />}
                                            variant='contained'
                                            className='btn__whatsapp'
                                            onClick={() => window.open(`https://wa.me/+5566999815612?text=Olá, gostaria de mais informações sobre ${veiculo.marca.nome} ${veiculo.modelo} ${veiculo.ano_fabricacao} ${url}`, '_blank')}
                                        >
                                            WhatsApp
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='pt-4 pb-4'>
                            <h6>Descrição</h6>
                            <Divider sx={{ borderColor: '#777777 !important', opacity: 1, mt: 3, mb: 3 }} />
                            <p dangerouslySetInnerHTML={formatObs()}></p>
                        </div>
                    </div>

                    <div className='bg-white mt-4'>
                        <div className='veiculosecia__content'>
                            <div className='mb-2'>
                                <Typography variant='h6' sx={{ fontSize: '16px' }}>Relacionados</Typography>
                                <Link to='/estoque' className='relacionados__link'>Ver mais</Link>
                            </div>
                            <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4'>
                                {isLoadingRelacionados ? (
                                    <div className='col text-center w-100'>
                                        <CircularProgress />
                                    </div>
                                ) : error ? (
                                    <div className='col text-center w-100'>
                                        <Alert severity='error'>{errorRelacionados}</Alert>
                                    </div>
                                ) : relacionados.length === 0 ? (
                                    <div className='col text-center w-100'>
                                        <Typography variant='h6'>Nenhum veículo relacionado encontrado.</Typography>
                                    </div>
                                ) : (
                                    relacionados.map(vehicle => (
                                        <div className='col' key={vehicle.id}>
                                            <VeiculoseciaVehicleCard vehicle={vehicle} />
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    </div>

                </>
            )}
        </>
    )
}

export default VeiculoseciaAnuncio;
